export const getModalSx = () => (
    {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(4px)",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
    }
)
export const getCardSx = (isOpen, isLoading) => (
    {
        position: "relative",
        // smaller placeholder size while loading, then expand to full available size
        maxWidth: isLoading ? "40vw" : "95vw",
        maxHeight: isLoading ? "40vh" : "95vh",
        width: isLoading ? "240px" : "auto",
        height: isLoading ? "240px" : "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: isLoading ? "hidden" : "auto", // enables scroll if needed
        borderRadius: 2,
        backgroundColor: "black",
        // smooth transitions when the size changes / when opacity toggles
        transition: "width 300ms cubic-bezier(.2,.8,.2,1), height 300ms cubic-bezier(.2,.8,.2,1), max-width 300ms cubic-bezier(.2,.8,.2,1), max-height 300ms cubic-bezier(.2,.8,.2,1), opacity 200ms linear",
        opacity: isOpen ? 1 : 0,
        willChange: "width, height, max-width, max-height, opacity",
    }
)
export const getCloseButtonSx = () => (
    {
        position: "absolute",
        top: 8,
        right: 8,
        zIndex: 2,
        backgroundColor: "rgba(255, 255, 255, 0.6)",
    }
)
export const getImageBoxSx = () => (
    {
        maxWidth: "800px",
        minWidth: "300px",
        maxHeight: "80vh",
        width: "auto",
        height: "auto",
        objectFit: "contain",
    }
)